import flowplayer from "@flowplayer/player";
const PACKAGE_NAME = "react-flowplayer";
export function trackBehaviorUsage(player, behavior, sample_rate = 1.0) {
    let reportedOnce = false;
    // analytics backed only handles events with media_id, so we need to ensure that it is set
    player.on(flowplayer.events.SOURCE, () => {
        var _a, _b;
        const hasMediaIdLike = typeof ((_a = player.opts.metadata) === null || _a === void 0 ? void 0 : _a.media_id) === "string" ||
            typeof ((_b = player.opts.metadata) === null || _b === void 0 ? void 0 : _b.stream_target_id) === "string";
        if (!reportedOnce && hasMediaIdLike) {
            player.emit("flowplayer:feature", {
                feature_name: PACKAGE_NAME,
                behavior,
                sample_rate,
            });
            reportedOnce = true;
        }
    });
}
